import { render, staticRenderFns } from "./ganhuo-list.vue?vue&type=template&id=b59c6b24&scoped=true&"
import script from "./ganhuo-list.vue?vue&type=script&lang=js&"
export * from "./ganhuo-list.vue?vue&type=script&lang=js&"
import style0 from "./ganhuo-list.scss?vue&type=style&index=0&id=b59c6b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59c6b24",
  null
  
)

export default component.exports